import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TrpcService } from '../../services/trpc/trpc.service';

import Chart from 'chart.js/auto';
import 'chartjs-adapter-date-fns';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { PerformaceMetricsFilter } from '../../../../../express-tRPC/src/api/lots/types';

@Component({
  selector: 'app-performace-metrics',
  templateUrl: './performace-metrics.component.html',
  styleUrl: './performace-metrics.component.scss'
})
export class PerformaceMetricsComponent {
  data: any;

  options: any;

  isLocationsLoading: boolean = false;
  filteredParkingLocations: any[] = [];
  parkingLocations: Location[] = [];
  selectedParkingLocation: any = undefined;

  serviceDropDownOptions: any[] = [];
  selectedService: any;
  isServicesLoading: boolean = false;

  searchByRangeDates: Date[] = [new Date(), new Date()];
  minDate: Date;
  maxDate: Date;

  intervalDropDownOptions: any[] = [
    { name: '1 Minute', value: 60 },
    { name: '5 Minute', value: 300 },
    { name: '15 Minute', value: 900 },
    { name: '30 Minute', value: 1800 },
    { name: '1 Hour', value: 3600 },
    { name: '24 Hour', value: 86400 }
  ];
  selectedInterval: any = 300;

  chart: any = [];
  metricsDataResponse: any = undefined;

  constructor(
    private messageService: MessageService,
    private trpcService: TrpcService,
  ) {
    let date = new Date();

    this.minDate = new Date();
    this.minDate.setMonth(date.getMonth());
    this.minDate.setDate(date.getDate() - 1);
    this.minDate.setFullYear(date.getFullYear());
    this.maxDate = new Date();
    this.searchByRangeDates = [this.minDate, this.maxDate];
    console.log(this.searchByRangeDates);
  }

  ngOnInit() {
    this.drawBlankChart();
    this.getLocations();
    this.getServices();
  }

  drawBlankChart(): void {
    this.chart = new Chart('canvas', {
      type: 'line',
      data: {
        labels: [],
        datasets: [
        ],
      },
      options: {
        scales: {
          x: {
            ticks: {
              // display: false
              autoSkip: false
            }
          },
          y: {
            beginAtZero: true,
          },
        },
        plugins: {
          tooltip: {
              callbacks: {
                  label: (context) => {
                      let label = [context.dataset.label || ''];

                      if (this.metricsDataResponse['data'][context.dataset.label!]) {

                          const metricsData = this.metricsDataResponse['data'][context.dataset.label!].find((data: any) => data['period'] == context.label);
                          if(metricsData) {
                            label.push('Count: '+metricsData['event_count']);
                            label.push('Max duration: '+metricsData['max_duration']);
                            label.push('Min duration: '+metricsData['min_duration']);
                            label.push('Avg duration: '+metricsData['avg_duration']);
                          }
                      }

                      return label;
                  }
              }
          }
        }
      },
    });
  }

  async getLocations(): Promise<void> {

    this.isLocationsLoading = true;

    let locationResponse: any = await this.trpcService.trpc.lots.getLocations.query().catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
      this.isLocationsLoading = false;
    });
    if(locationResponse.length) {
      this.parkingLocations = locationResponse;
      this.isLocationsLoading = false;
    }
  }

  filterParkingLocations(event: AutoCompleteCompleteEvent) {
    let query = event.query;

    this.filteredParkingLocations = this.parkingLocations.filter((location: any) => {
      return (location.name.toLowerCase().indexOf(query.toLowerCase()) != -1 || String(location.id).toLowerCase().indexOf(String(query)) != -1)
    });
  }

  async getServices(): Promise<void> {

    this.isServicesLoading = true;

    let serviceResponse: any = await this.trpcService.trpc.lots.getServices.query().catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
      this.isLocationsLoading = false;
    });
    if(serviceResponse.length) {
      console.log(serviceResponse)
      this.serviceDropDownOptions = serviceResponse.map((service: any) => {
        return { code: service['performance_metrics_service'], name: service['performance_metrics_service'] };
      })
      // this.parkingLocations = locationResponse;
      this.isServicesLoading = false;
    }
  }

  async loadChartData(): Promise<void> {
    console.log(this.chart)
    this.chart.destroy();
    this.drawBlankChart();
    // console.log(this.selectedParkingLocation);
    // console.log(this.selectedService);
    // console.log(this.searchByRangeDates)
    const filters: PerformaceMetricsFilter = {
      location: this.selectedParkingLocation?.map((location: any) => location['id']),
      services: this.selectedService?.map((service: any) => service['code']),
      range: this.searchByRangeDates,
      interval: this.selectedInterval
    }
    this.metricsDataResponse = await this.trpcService.trpc.lots.getPermanceMetrics.mutate(filters).catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
      this.isLocationsLoading = false;
    });

    if(this.metricsDataResponse) {

      if(Object.keys(this.metricsDataResponse?.data).length) {

        const diff = Math.ceil((new Date(this.metricsDataResponse['max_period']).getTime() - new Date(this.metricsDataResponse['min_period']).getTime()) / (this.selectedInterval * 1000));

        let min_period = this.metricsDataResponse['min_period'];
        let max_period = this.metricsDataResponse['max_period'];
        let labels: string[] = [min_period];

        for (let index = 0; index < diff; index++) {
            min_period = new Date(min_period).setMinutes(new Date(min_period).getMinutes() + this.selectedInterval / 60);
            let new_min_period = new Date(min_period).toLocaleString([], {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false, second: '2-digit'});
            let new_min_period_date = new_min_period.split(", ")[0].replaceAll("/", "-");
            let new_min_period_time = new_min_period.split(", ")[1];
            let new_min_period_formatted = new_min_period_date.split("-")[2] +"-"+new_min_period_date.split("-")[0]+"-"+new_min_period_date.split("-")[1] +" "+new_min_period_time;
            // console.log(new_min_period_formatted)
            labels.push(new_min_period_formatted);
        }

        this.chart.config.data.labels = labels;

        let index = 0;
        for (const key in this.metricsDataResponse.data) {

          const locationData = this.metricsDataResponse.data[key];


          if (!this.chart.config.data.datasets[index]) {
            this.chart.config.data.datasets.push({label: '', data: []});
          } else {
            this.chart.config.data.datasets[index].label = '';
            this.chart.config.data.datasets[index].data = [];
          }

          this.chart.config.data.datasets[index].label = key;
          let data_points = labels.map((label: string) => {
            const matchedIndex = locationData.findIndex((data: any) => data.period == label);
            return (matchedIndex !== -1) ? Number(locationData[matchedIndex].avg_duration) : 0;
          });

          this.chart.config.data.datasets[index].data = data_points;
          // this.chart.config.data.datasets[index].data = locationData.map((data: any) => Number(data.avg_duration));

          index++;
        }

        this.chart.update();
        this.isLocationsLoading = false;
      } else {
        this.messageService.add({
          severity: "error",
          detail: "No data available.",
        });
        this.isLocationsLoading = false;
      }
    }

  }

}
